import { FC, ReactNode } from 'react'
import { isSameDay } from 'date-fns'

import { formatDate } from '@/helpers/date'
import { trans } from '@/helpers/trans'

import './DayContent.scss'

function getSameDay(day: Date) {
    return isSameDay(new Date(day), new Date())
}

interface DayContentProps {
    day: Date
    children: ReactNode
    showHeader?: boolean
}

export const DayContent: FC<DayContentProps> = ({
    day,
    children,
    showHeader = true,
}) => {
    const sameDay = getSameDay(day)

    return (
        <div className={`day-content day-content ${sameDay && 'day-content--today'}`}>
            {showHeader && (
                <div className={`day-content__header day-content-header-absence ${sameDay && 'day-content-header--today'}`}>
                    <div className="day-content__header-label">
                        { sameDay && trans('common.today') }
                    </div>
                    <div className={`day-content__header-day ${sameDay && 'day-content-header-day--today'}`}>
                        {formatDate(new Date(day), 'd')}
                    </div>
                </div>
            )}
            {children}
        </div>
    )
}
